import api from './api';

export const login = async (username, password) => {
    try {
        const response = await api.post('/api/auth/signin', { username, password });
        return response.data;
    } catch (error) {
        return { result: false, msg: 'Error de conexión.' };
    }
};